(function () {
    'use strict';

    angular
            .module('imnApp')
            .directive('eventClickout', eventClickout);

    function eventClickout() {
        return {
            restrict: 'A',
            scope: {
                eventAction: '&'
            },
            link: function (scope, element, attr) {
                angular.element(document).on('click', function (evt) {
                    if (!angular.element(evt.target).closest(element).length) {
                        scope.$apply(scope.eventAction);
                    }
                });
            }
        }
    }

})();